import { registerQuery, useQuery as useDfcQuery } from 'data-fetching-client';
import { useMemo, useEffect } from 'react';
import { useCrmLocationAdapter } from '../useCrmLocationAdapter';
import { getDefaultFasAdapter } from './utils/fasLocationAdapter';
import { logLocationQueryErrors } from './logLocationQueryErrors';
import { fetchCrmLocation } from './utils/fetchCrmLocation';
import mark from 'crm-fe-perf/timing/mark';
import measure from 'crm-fe-perf/timing/measure';
import { CrmLocationResolverQueryStart, CrmLocationResolverQueryFinish, CrmLocationResolverQueryFASStart, CrmLocationResolverQueryFASFinish } from 'crm-fe-perf/timing/marks/crm-cards-sdk/performanceMarks';
import { CrmLocationResolverQuery, CrmLocationResolverFASQuery } from 'crm-fe-perf/timing/measurements/crm-cards-sdk/performanceMeasurements';
import useMarkOnMount from 'crm-fe-perf/timing/hooks/useMarkOnMount';
export const GET_FAS_LOCATION = registerQuery({
  fieldName: 'location',
  args: ['objectTypeId', 'objectId', 'location'],
  fetcher: fetchCrmLocation
});
const useDfcQueryWithMarks = (perfDimensions, ...args) => {
  useEffect(() => {
    mark(CrmLocationResolverQueryFASStart, perfDimensions, true);
  }, [perfDimensions]);
  const res = useDfcQuery(...args);
  useEffect(() => {
    if (res.data) {
      mark(CrmLocationResolverQueryFASFinish, perfDimensions, true);
      measure(CrmLocationResolverFASQuery, perfDimensions, true);
    }
  }, [res.data, perfDimensions]);
  return res;
};
export const useCrmLocationResolverQuery = ({
  location,
  objectId,
  objectTypeId,
  loggingTag,
  transformCrmLocation
}) => {
  const cardLocationQueryVariables = useMemo(() => ({
    location,
    objectId,
    objectTypeId
  }), [location, objectId, objectTypeId]);
  const perfDimensions = useMemo(() => ({
    location,
    logging_tag: loggingTag || ''
  }),
  // We don't track the objectId, but we should re-measure whenever the query changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [location, loggingTag, cardLocationQueryVariables]);
  useMarkOnMount(CrmLocationResolverQueryStart, perfDimensions, true);
  const {
    data,
    error,
    loading,
    refetch
  } = useDfcQueryWithMarks(perfDimensions, GET_FAS_LOCATION, {
    variables: cardLocationQueryVariables,
    onError: e => {
      logLocationQueryErrors({
        error: e,
        errorPrefix: 'crmLocation FAS query error',
        location,
        loggingTag,
        objectId,
        objectTypeId,
        source: 'useCrmLocationResolverQuery::GET_FAS_LOCATION'
      });
    }
  });
  const crmLocationAdapter = useMemo(() => getDefaultFasAdapter(), []);
  const crmLocation = useCrmLocationAdapter(crmLocationAdapter, data && data.location, transformCrmLocation);
  useEffect(() => {
    if (crmLocation) {
      mark(CrmLocationResolverQueryFinish, perfDimensions, true);
      measure(CrmLocationResolverQuery, {}, true);
    }
  });
  return {
    loading,
    error,
    crmLocation,
    refetch
  };
};